import { useEffect } from 'react'
import { getShopId, queryClient, useTranslate } from 'old/utils'
import { useField } from 'react-final-form'
import { useUserRemove } from 'old/api'
import { FormRemove } from 'old/components/form-remove/form-remove'
import { useNavigate } from 'react-router-dom'
import { message } from 'antd'

export const UserRemove = () => {

    //translate:
    const { __ } = useTranslate()

    //navigation:
    const navigate = useNavigate()

    //field:
    const { input: { value: id } } = useField('id')

    //mutation:
    const { mutate, isLoading, data: response } = useUserRemove(id)

    //effect:
    useEffect(() => {
        if(response){
            queryClient.invalidateQueries(['users', getShopId()])
            message.success(__`user_removed`)
            navigate('/user')
        }
    }, [response])
    
    //render:
    return (
        <FormRemove
            title={__`remove_user`}
            message={__`all_the_access_will_be_deleted_this_action_cant_be_undone`}
            description={__`this_will_not_remove_the_user_from_other_shops`}
            isLoading={isLoading}
            onRemove={mutate}
        />
    )

}
